<template>
	<label class="label bdSub taC" :class="[addClass, sizeClass]" :title="text">{{ text }}</label>
</template>
<script>
export default {
	components: {},
	props: {
		// type:{
		// 	type:String,
		// 	default:""
		// },
		text: {
			type: String,
			default: "",
		},
		addClass: {
			type: String,
			default: "",
		},
		size: {
			type: String,
			default: "m", // s,m,l,xl
		},
	},
	data() {
		return {
			// val:this.value,
			// o:{
			// 	autocomplete:this.option.autocomplete||null
			// }
		};
	},
	// watch:{
	// 	val(_val){
	// 		this.$emit("input",_val);
	// 	}
	// },
	methods: {
		// _click:function($event){
		// 	this.$emit("click",$event.currentTarget);
		// }
	},
	computed: {
		sizeClass: function () {
			switch (this.size) {
				case "m":
					return "sizeM sizeM-lh";
					break;
			}
		},
	},
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/ui/Label.vue